import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {CustomValidators} from '../../validator/custom-validator';
import {CompanyService} from '../../services/company-service/company.service';
import {filter, take} from 'rxjs';
import {Store} from '@ngrx/store';
import {CompanyAppState} from '../../store/company/reducers/company.reducer';
import {selectCompanyPage} from '../../store/company/selectors/company.selectors';
import {CompanyPage} from '../../model/company-page';
import {QuestionOptions} from 'src/app/constants/question-options';

@Component({
    selector: 'app-company-profile-edit',
    templateUrl: './company-profile-edit.component.html',
    styleUrls: ['../../../styles/form-input.scss', '../../../styles/edit-style.scss'],
    standalone: false
})
export class CompanyProfileEditComponent implements OnInit {
  formGroup = this.fb.group({
    emailAddress: ['', [Validators.required, CustomValidators.notOnlyWhitespace]],
    telephoneNumber: '',
    street: ['', [Validators.required, CustomValidators.notOnlyWhitespace]],
    houseNumber: ['', [Validators.required, CustomValidators.notOnlyWhitespace]],
    postalCode: ['', [Validators.required, CustomValidators.notOnlyWhitespace]],
    location: ['', [Validators.required, CustomValidators.notOnlyWhitespace]],
    countryCode: ['', [Validators.required, CustomValidators.notOnlyWhitespace]],
    faxNumber: '',
    description: '',
    seatNumber: '',

  });
  QuestionOptions = QuestionOptions;
  companyId: string;
  @Output() updated = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  constructor(private readonly fb: FormBuilder,
              public companyStore: Store<CompanyAppState>,
              private readonly companyService: CompanyService) {
  }

  ngOnInit(): void {
    this.companyStore.select(selectCompanyPage)
      .pipe(filter(companyPage => companyPage != null),
        take(1)).subscribe(
      companyPage => {
        this.formGroup.patchValue(companyPage);
        this.companyId = companyPage.companyId;
      }
    );
  }

  submit() {
    const companyPage = new CompanyPage(this.formGroup.getRawValue());
    this.companyService.updateCompanyPage(this.companyId, companyPage).subscribe(
      _ => this.updated.emit()
    );
  }

  emitClose() {
    this.close.emit();
  }
}
